import * as amplitude from "@amplitude/analytics-browser";
import { ReactNode, useEffect } from "react";

import { AnalyticsContext, AnalyticsContextState } from "./AnalyticsContext";

type AmplitudeAnalyticsProviderProps = {
  apiKey: string;
  children: ReactNode;
};

const amplitudeAnalytics: AnalyticsContextState = {
  setUser: (id) => {
    amplitude.setUserId(id);
  },
  trackEvent: (name, data) => {
    amplitude.track(name, data);
  },
  setUserProperties: (properties) => {
    const identify = new amplitude.Identify();
    Object.entries(properties).forEach(([key, value]) => {
      identify.set(key, value as string | number | boolean | Array<string>);
    });
    amplitude.identify(identify);
  },
  identifyVisitor: (session) => {
    // Set user ID
    amplitude.setUserId(session.userId);

    // Set user properties for visitor identification
    const identify = new amplitude.Identify();
    identify.set(
      "visitor_type",
      session.loginCount === 1 ? "new_user" : "returning_user"
    );
    identify.set("first_seen_date", session.firstSeenDate);
    identify.set("login_count", session.loginCount);
    identify.set("last_login_date", session.lastLoginDate);
    identify.set("username", session.username);

    amplitude.identify(identify);
  },
};

export const AmplitudeAnalyticsProvider = ({
  apiKey,
  children,
}: AmplitudeAnalyticsProviderProps) => {
  useEffect(() => {
    amplitude.init(apiKey);
  }, [apiKey]);

  return (
    <AnalyticsContext.Provider value={amplitudeAnalytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};
